import { ZendeskUsersResponse } from "../types/Zendesk";
import { zendeskRequest } from "./zendesk";

export async function getUsersByIds(
  userIds: number[]
): Promise<ZendeskUsersResponse> {
  const ids = userIds.join(",");
  return zendeskRequest<ZendeskUsersResponse>(
    `/api/v2/users/show_many.json?ids=${ids}`,
    "GET"
  );
}
